import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";
import { ServiceFeeGroupService } from "./fee-service";

export const serviceFeeGroupApi = createApi({
  reducerPath: "serviceFeeGroupApi",
  baseQuery: createBaseQuery(""),
  tagTypes: ["ServiceFeeGroup", "ServiceFeeScale"],
  endpoints: (build) => ({
    getServiceFeeGroup: build.query<ServiceFeeGroup, ServiceFeeGroupParams>({
      query: ({ companyId, serviceId, groupId }) => ({
        url: ServiceFeeGroupService.getEndpointUrl(
          { companyId, serviceId },
          `/${groupId}`
        ),
        method: "GET",
      }),
      providesTags: ["ServiceFeeGroup"],
    }),

    deleteServiceFeeGroup: build.mutation<void, ServiceFeeGroupParams>({
      query: ({ companyId, serviceId, groupId }) => ({
        url: ServiceFeeGroupService.getEndpointUrl(
          { companyId, serviceId },
          `/${groupId}`
        ),
        method: "DELETE",
      }),
      invalidatesTags: ["ServiceFeeGroup"],
    }),

    editServiceFeeGroup: build.mutation<
      ServiceFeeGroup,
      ServiceFeeGroupParams & { data: ServiceFeeGroupData }
    >({
      query: ({ companyId, serviceId, groupId, data }) => ({
        url: ServiceFeeGroupService.getEndpointUrl(
          { companyId, serviceId },
          `/${groupId}`
        ),
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ServiceFeeGroup"],
    }),

    createServiceFeeGroup: build.mutation<
      ServiceFeeGroup,
      BaseServiceFeeParams & { data: ServiceFeeGroupData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: ServiceFeeGroupService.getEndpointUrl({ companyId, serviceId }),
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ServiceFeeGroup"],
    }),

    listGroups: build.query<
      ServiceFeeGroup[],
      BaseServiceFeeParams & { search?: string }
    >({
      query: ({ companyId, serviceId, search }) => ({
        url:
          ServiceFeeGroupService.getEndpointUrl({ companyId, serviceId }) +
          (search ? `?search=${search}` : ""),
        method: "GET",
      }),
      providesTags: ["ServiceFeeGroup"],
    }),

    deleteScale: build.mutation<void, ServiceFeeScaleParams>({
      query: ({ companyId, serviceId, scaleId }) => ({
        url: ServiceFeeGroupService.getEndpointUrl(
          { companyId, serviceId },
          `/scale/${scaleId}`
        ),
        method: "DELETE",
      }),
      invalidatesTags: ["ServiceFeeScale"],
    }),

    editScale: build.mutation<
      ServiceFeeScale,
      ServiceFeeScaleParams & { data: ServiceFeeScaleData }
    >({
      query: ({ companyId, serviceId, scaleId, data }) => ({
        url: ServiceFeeGroupService.getEndpointUrl(
          { companyId, serviceId },
          `/scale/${scaleId}`
        ),
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ServiceFeeScale"],
    }),

    createScale: build.mutation<
      ServiceFeeScale,
      BaseServiceFeeParams & { data: ServiceFeeScaleData }
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: ServiceFeeGroupService.getEndpointUrl(
          { companyId, serviceId },
          "/scale"
        ),
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ServiceFeeScale"],
    }),

    listScales: build.query<ServiceFeeScale[], ServiceFeeGroupParams>({
      query: ({ companyId, serviceId, groupId }) => ({
        url: ServiceFeeGroupService.getEndpointUrl(
          { companyId, serviceId },
          `/${groupId}/scale`
        ),
        method: "GET",
      }),
      providesTags: ["ServiceFeeScale"],
    }),
  }),
});
